import React from 'react';
import { SectionFade } from './ui/SectionFade';
import { ShieldIcon } from 'lucide-react';
export function Solution() {
  return <section className="py-24 px-4 bg-brand-black relative border-y border-brand-neon/20" data-id="element-146">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(200,255,0,0.08)_0%,transparent_70%)] pointer-events-none" data-id="element-147"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-148">
        <SectionFade data-id="element-149">
          <div className="inline-flex items-center justify-center p-4 bg-brand-neon/10 rounded-full mb-8" data-id="element-150">
            <ShieldIcon className="text-brand-neon" size={48} data-id="element-151" />
          </div>
        </SectionFade>

        <SectionFade delay={0.1} data-id="element-152">
          <h2 className="font-bebas text-6xl md:text-8xl mb-8 tracking-tight" data-id="element-153">
            EL TRADUCTOR DE <span className="text-brand-neon" data-id="element-154">ETIQUETAS</span>
          </h2>
        </SectionFade>

        <SectionFade delay={0.2} data-id="element-155">
          <p className="text-xl md:text-2xl font-inter text-gray-300 leading-relaxed mb-8" data-id="element-156">
            He creado un protocolo de decodificación instantánea.{' '}
            <strong className="text-white" data-id="element-157">No necesitas ser bioquímico;</strong>{' '}
            solo necesitas saber qué palabras buscar.
          </p>
        </SectionFade>

        <SectionFade delay={0.3} data-id="element-158">
          <p className="text-xl md:text-2xl font-inter text-brand-neon/90 font-medium leading-relaxed" data-id="element-159">
            Este manual convierte el lenguaje técnico de laboratorio en verdades
            crudas, permitiéndote limpiar tu despensa y tu cuerpo en tiempo
            récord.
          </p>
        </SectionFade>
      </div>
    </section>;
}